(function () {
  const MIN_AMOUNT = 500;
  const DEBOUNCE = 250;
  let t, inflight = null;

  const cache = new Map();
  const wrap = document.querySelector('.svea-part-payment-widget');
  if (!wrap) return;

  const out = wrap.querySelector('.svea-amount');
  const totalNode = document.getElementById('total-price');
  const packagesNode = document.getElementById('package-count');

  function parseSEKToCents(txt) {
    if (!txt) return 0;
    txt = txt.replace(/\u00a0/g, '').replace(/\s+/g, '').replace(/[^0-9,.\-]/g, '');
    const m = txt.match(/^(.+?)([.,])(\d{2})$/);
    const cents = m
      ? Math.round(Number(m[1].replace(/[.,]/g, '') + '.' + m[3]) * 100)
      : Math.round(Number(txt.replace(/[.,]/g, '')) * 100);
    return Number.isFinite(cents) ? cents : 0;
  }

  function getTotalCents() {
    if (totalNode) {
      const txt = (totalNode.textContent || '').trim();
      if (/\d/.test(txt)) {
        return parseSEKToCents(txt);
      }
    }
    const ds = wrap.dataset.priceCents;
    const v = Number(ds || 0);
    return Number.isFinite(v) ? v : 0;
  }

  function fetchCampaigns(amount) {
    if (cache.has(amount)) return Promise.resolve(cache.get(amount));
    const url = `/apps/svea/util/GetAvailablePartPaymentCampaigns?isCompany=false&amount=${amount.toFixed(2)}&ts=${Date.now()}`;
    inflight?.abort?.();
    const ctrl = new AbortController();
    inflight = ctrl;

    return fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl.signal })
      .then(r => {
        const ct = r.headers.get('content-type') || '';
        if (!r.ok || !ct.includes('application/json')) throw new Error('Bad response');
        return r.json();
      })
      .then(list => {
        const normalized = Array.isArray(list) ? list : [];
        cache.set(amount, normalized);
        return normalized;
      })
      .catch(() => []);
  }

  function bestMonthly(list) {
    if (!Array.isArray(list) || !list.length) return null;
    return list.reduce((m, c) => (!m || Number(c.MonthlyAmount) < Number(m.MonthlyAmount) ? c : m), null);
  }

function hide() {
  // Lägg bara till klassen, låt CSS hantera transition och visibility
  wrap.classList.add('is-hidden');
}

function show() {
  // Ta bort klassen för att trigga fade in
  wrap.classList.remove('is-hidden');
}


  function render() {
    const cents = getTotalCents();
    const amount = +(cents / 100).toFixed(2);

    if (!cents || !Number.isFinite(amount) || amount < MIN_AMOUNT) {
      hide();
      return;
    }

    fetchCampaigns(amount)
      .then(list => {
        const b = bestMonthly(list);
        if (b) {
          show();
          out.textContent = `${Math.round(Number(b.MonthlyAmount))} kr/månad`;
        } else {
          hide();
        }
      })
      .catch(() => {
        hide();
      });
  }

  function schedule() { clearTimeout(t); t = setTimeout(render, DEBOUNCE); }

  if (totalNode) new MutationObserver(schedule).observe(totalNode, { childList: true, characterData: true, subtree: true });
  if (packagesNode) new MutationObserver(schedule).observe(packagesNode, { childList: true, characterData: true, subtree: true });

  setInterval(schedule, 8000);
  ['variant:change', 'product:variant:change', 'quantity:change'].forEach(ev =>
    document.addEventListener(ev, schedule)
  );

  render();
})();
